<template>
    <div class="fill-height pt-2">
		<!-- dialog add or edit role -->
		<v-dialog v-model="dialog" width="300">
			<v-form @submit.prevent="submit">
				<v-card class="rounded-lg">
					<v-card-title class="py-2">
						<span class="title"> {{ !roleId ? 'Add new role' : 'Edit role' }} </span>
					</v-card-title>

					<v-card-text class="pt-1 pb-2">
						<v-row class="pt-2">
							<!-- name -->
							<v-col cols="12" class="pt-0 pb-1 px-1">
								<v-text-field	
									v-model="dialogData.name"
									label= 'Name'
									solo
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									dense
									:loading="submitLoading"
									filled
									hide-details
									class="rounded-lg input"
									:disabled="submitLoading"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="pt-0 pb-1 px-1">
								<v-textarea	
									v-model="dialogData.description"
									label= 'Description'
									solo
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									dense
									:loading="submitLoading"
									filled
									hide-details
									class="rounded-lg input"
									:disabled="submitLoading"
									rows="2"
								/>
							</v-col>
						</v-row>
					</v-card-text>

					<v-card-actions>
						<v-spacer />
						<v-btn
							color="green-color white--text"
							class="text-none rounded-lg"
							:loading="submitLoading"
							@click="submit"
						>
							Save
						</v-btn>

						<v-btn
							@click="dialog = false"
							color="alert-color white--text"
							class="text-none rounded-lg"
							:disabled="submitLoading"
						> 
							Cancel
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- delete dialog -->
		<v-dialog v-model="deleteDialog" width="400">
			<v-card>
				<v-card-title class="pt-3 pb-1">
					<span class="title"> Delete role </span>
				</v-card-title>

				<v-card-text class="pb-1 pt-0 px-5">
					Are you sure you want to delete this role ?
				</v-card-text>

				<v-card-actions class="pt-0">
					<v-spacer />
					<v-btn
						@click="deleteRole()"
						color="alert-color white--text"
						class="text-none rounded-lg"
						type="submit"
						:loading="submitLoading"
					>
						Yes
					</v-btn>

					<v-btn
						text
						@click="deleteDialog = false"
						class="text-none"
						:disabled="submitLoading"
					>						
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<div>
			<!-- title -->
			<div class="pb-0 pb-sm-1 pt-0 px-0 d-flex">	
				<v-spacer />
				<v-btn @click="dialog = true" color="green-color white--text" class="text-none rounded-lg">
					<v-icon small> mdi-plus </v-icon>
					Add new role 
				</v-btn>
			</div>
		</div>

        <bee-handy-table
            :headers="headers"
            :items="rolesInProject"
			table-class="rounded-lg elevation-0"
			class="mt-0"
			dense
			zebra
			:height="$vuetify.breakpoint.height - 220"
			pagination-on-scroll
			:items-per-page="-1"
        >
			<template v-slot:item.actions="{ item }">
				<div>
					<v-btn
						@click="roleId = item.id; dialog = true"
						icon
						color="edit-color"
					>
						<v-icon>mdi-pencil</v-icon>
					</v-btn>

					<v-btn @click="roleId = item.id; deleteDialog = true" icon color="alert-color">
						<v-icon>mdi-delete</v-icon>
					</v-btn>
				</div>
			</template>
		</bee-handy-table>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
	watch: {
		dialog (val) {
			if (val) {
				if (this.roleId) {
					this.dialogData.name = this.getRoleById(this.roleId)?.name
					this.dialogData.description = this.getRoleById(this.roleId)?.description
				}
			} else {
				this.dialogData.name = null
				this.dialogData.description = null
				this.roleId = null
			}
		}
	},

	data () {
		return {
			items: [{ id: 2, name: 'role', description: 'The person' }],
			dialogData: {
				name: null,
				description: null
			},

			dialog: false,
			roleId: null,
			loading: false,
			deleteDialog: false,
			submitLoading: false
		}	
	},

	computed: {
		...mapState({
			rolesInProject: state => state.rolesInProject.rolesInProject
		}),

		...mapGetters({
			getRoleById: 'rolesInProject/getRoleById'
		}),

		headers () {
			return [
				{
					text: 'Name',
					name: 'name',
					value: 'name'
				},
				{
					text: 'description',
					name: 'description',
					value: 'description'
				},
				{
					text: 'actions',
					name: 'actions',
					value: 'actions'
				}
			]
		}
	},

	methods: {
		submit () {
			this.submitLoading = true 
			const actionName = this.roleId ? 'update' : 'create'
			this.$store.dispatch(`rolesInProject/${actionName}`, { 
				id: this.roleId,
				name: this.dialogData.name, 
				description: this.dialogData.description 
			}).then(() => {
				this.loading = true
				this.$store.dispatch('rolesInProject/fetchAll')
			}).finally(() => {
				this.submitLoading = false
				this.loading = false
				this.dialog = false 
			})
		},

		deleteRole () {
			this.submitLoading = true
			this.$store.dispatch('rolesInProject/delete', { id: this.roleId }).then(() => {
				this.$store.dispatch('rolesInProject/fetchAll')
			}).finally(() => {
				this.roleId = null
				this.submitLoading = false
				this.deleteDialog = false
			})
		}
	},

	created () {
		this.loading = true
		this.$store.dispatch('rolesInProject/fetchAll').finally(() => {
			this.loading = false
		})
	}
}
</script>

<style scoped>

</style>
